import React from 'react';

interface Icon3DMegaphoneProps {
  size?: string;
}

const Icon3DMegaphone: React.FC<Icon3DMegaphoneProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1200px' }}>
      <div 
        className="w-full h-full relative"
        style={{
          animation: 'scale-pulse 2s ease-in-out infinite',
          transformStyle: 'preserve-3d'
        }}
      >
        <svg 
          viewBox="0 0 24 24" 
          fill="none" 
          className="w-full h-full"
          style={{
            filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.2))'
          }}
        >
          <defs>
            <linearGradient id="megaGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#ec4899" />
              <stop offset="100%" stopColor="#db2777" />
            </linearGradient>
          </defs>
          <path d="M4 10l8-6v12z" fill="url(#megaGradient)" />
          <circle cx="16" cy="10" r="3" fill="url(#megaGradient)" />
        </svg>
        <style>{`
          @keyframes scale-pulse {
            0%, 100% { transform: scale(1) rotateX(0deg); }
            50% { transform: scale(1.1) rotateX(5deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Icon3DMegaphone;
